import { Component, ViewEncapsulation } from '@angular/core';
import { UIHelpers } from '../../../../core/ui-helpers';
import { BasePage } from '../../../../pages/BasePage';

@Component({
  selector: 'app-style-guide-page',
  templateUrl: './style-guide-page.component.html',
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class StyleGuidePageComponent extends BasePage {
  constructor(public uiHelpers: UIHelpers) {
    super();
  }

  override ngOnInit() {
    super.ngOnInit();
  }

  public jumpToSection(selector: string) {
    UIHelpers.scrollToTop(selector);
  }
}
